import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["user", "type", "colorScheme", "href", "className"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classNames from 'classnames';
import { AppContext } from "../DixuApp/DixuApp";
import DixuAvatar from "../DixuAvatar/DixuAvatar";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuLink from "../DixuLink/DixuLink";
import DixuSidebar from "../DixuSidebar/DixuSidebar";
import DixuText from "../DixuText/DixuText";
import React, { useContext } from 'react';
import { getImageUrl } from "../../utils/DixuListingUtils";
const DixuProfileInfo = _ref => {
  let {
      user,
      type,
      colorScheme,
      href,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-profile-info', {
    [`dixu-profile-info--type-${type}`]: type,
    [`dixu-profile-info--color-scheme-${colorScheme}`]: colorScheme
  }, className);
  const compact = type === 'compact';
  const {
    user: contextUser
  } = useContext(AppContext);
  const {
    avatar,
    picture,
    displayName,
    emails
  } = user || contextUser || {};
  const avatarSrc = avatar?.fd ? getImageUrl(avatar.fd) : picture;
  const email = emails?.[0]?.value;
  const WrapperTag = href ? DixuLink : 'div';
  const wrapperIsLink = WrapperTag === DixuLink;
  const wrapperProps = (() => {
    if (wrapperIsLink) {
      return {
        href,
        block: true
      };
    }
    return {};
  })();
  const mainColor = (() => {
    if (colorScheme === 'light') {
      return '2-1';
    }
    if (colorScheme === 'dark') {
      return '2-8';
    }
    return undefined;
  })();
  const secondaryColor = (() => {
    if (colorScheme === 'light') {
      return '2-5';
    }
    if (colorScheme === 'dark') {
      return '1-6';
    }
    return undefined;
  })();
  const EmailWrapperTag = wrapperIsLink ? DixuText : DixuLink;
  const emailWrapperProps = (() => {
    if (wrapperIsLink) {
      return {
        font: '1',
        color: secondaryColor,
        weight: 'medium',
        wrap: true
      };
    }
    return {
      font: '1',
      color: secondaryColor,
      weight: 'medium',
      href: `mailto:${email}`,
      wrap: true
    };
  })();
  return /*#__PURE__*/React.createElement(WrapperTag, _objectSpread(_objectSpread({
    className: classes
  }, wrapperProps), rest), /*#__PURE__*/React.createElement(DixuRow, {
    align: "middle",
    gutter: 16,
    wrap: false
  }, avatarSrc && /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuAvatar, {
    src: avatarSrc,
    size: compact ? 32 : 46
  })), !compact && /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuSidebar.Content, null, /*#__PURE__*/React.createElement(DixuText, {
    font: '2',
    color: mainColor,
    weight: 'bold',
    block: true,
    wrap: true
  }, displayName), email && /*#__PURE__*/React.createElement(EmailWrapperTag, _objectSpread({}, emailWrapperProps), email)))));
};
DixuProfileInfo.defaultProps = {
  type: undefined,
  colorScheme: 'light',
  user: undefined
};
export default DixuProfileInfo;